import React from "react";

const CalendarSection = () => {
  return (
    <section className="py-16 bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <h1
          className="text-3xl md:text-4xl font-bold text-primary-500 relative inline-block pb-4"
          style={{
            borderBottom: "3px solid #FFBF07",
          }}
        >
          {" "}
          <i className="fas fa-calendar-alt mr-2 text-secondary-500"></i>
          ปฏิทินกิจกรรม
        </h1>

        <div className="bg-white rounded-xl shadow-lg overflow-hidden mt-8">
          <iframe
            src="https://calendar.google.com/calendar/u/0/embed?color=%239fe1e7&src=lifelong@sskru.ac.th&ctz=Asia/Bangkok"
            className="w-full h-[500px] md:h-[600px]"
            title="Google Calendar"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default CalendarSection;
